import { useEffect, useState } from "react";
import AddIcon from "assets/svg/add.svg";
import Form from "@/components/common/form/form";
import { authServices } from "services/auth.services";
import Model from "@/components/common/model.component";
import Image from "next/image";
import { useSwrGet } from "@/utils/use-swr-get";
import PipesForm from "./pipesForm";
import { useTranslation } from "react-i18next";
import _objI from "@/utils/_objI";
import { WaterFlowService } from "services/assets-flowMeter.sevices";
import LocationModal from "./editLocationModal";
import { useDispatch, useSelector } from "react-redux";
import {
  clearField,
  clearGeoField,
  readTreeFields,
  readTreeGeoFields,
} from "@/redux/actions/tree/fields";
type Reducer = {
  treeFieldsReducer?: any;
  farmsReducer?: any;
};
const EditPipes = ({
  setRefresh,
  showModal,
  setShowModal,
  rowData,
  setRowData,
}) => {
  const [showLocationModal, setLocationModal] = useState(false);
  const {
    data: farmData,
    isLoading: farmIsLoading,
    isError: farmIsError,
  } = useSwrGet(
    `/farm/all`,
    process.env.NEXT_PUBLIC_BASE_URL +
      `farms/details/${authServices.userValue.org_id}/`
  );
  const { t } = useTranslation();

  const onSubmit = async (data) => {
    data.attributes_value.diameter_mm = Number(
      data.attributes_value.diameter_mm
    );
    data.attributes_value.sec_pipe_id = Number(
      data.attributes_value.sec_pipe_id
    );
    data.farm_id = Number(data.farm_id);
    data.object_id = Number(data.object_id);
    data.supplier_id = Number(data.supplier_id) || null;
    data.entity_type_id = 11;
    data.org_id = authServices.userValue.org_id;
    data.content_type = farmData
      ?.filter?.((item) => item.farm_id == data.farm_id)
      ?.map?.((item) =>
        item.farm_type === "tree"
          ? authServices.userValue.content_types
              ?.filter?.((item) => item.model == "treefieldinfo")
              ?.find?.((item) => item.id)?.id
          : authServices.userValue.content_types
              ?.filter?.((item) => item.model == "pivotfieldinfo")
              ?.find?.((item) => item.id)?.id
      )[0];
    let res = await WaterFlowService.editWaterFlow(data, rowData.id);
    if (res) {
      setLocationModal(!showLocationModal);
    }
  };
  const dispatch = useDispatch();

  const { farm } = useSelector((state: Reducer) => state.farmsReducer);
  useEffect(() => {
    dispatch(clearField());
    dispatch(clearGeoField());
    dispatch(readTreeFields(`?farm_id__id=${farm.id}`));
    dispatch(readTreeGeoFields(farm.id));
  }, [farm.id]);

  return (
    _objI(rowData) && (
      <>
        <Model
          width="w-130"
          show={showModal}
          onClose={(e) => {
            setShowModal(false);
            setRowData({});
          }}
        >
          <div className="flex items-center gap-2">
            <Image
              src={AddIcon}
              alt="icon"
              className=" text-mako"
              width="35"
              height="35"
            />
            <h2 className="text-lg font-bold text-mako">{t("EditPipes")}</h2>
          </div>
          <Form
            onSubmit={onSubmit}
            className="w-80 lg:w-96"
            defaultValues={_objI(rowData) ? { ...rowData } : {}}
          >
            <PipesForm RowData={rowData} passProps icon={""} />
          </Form>
        </Model>
        <LocationModal
          setRefresh={setRefresh}
          showModal={showLocationModal}
          setShowModal={setLocationModal}
          closeMainModal={setShowModal}
          rowData={{ rowData }}
        />
      </>
    )
  );
};
export default EditPipes;
